(function () {
	'use strict';

	angular.module('dcApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('public-root', {
			url: '',
			parent: 'root',
			abstract: true,
			views: {
				'app@': {
					template: '<ui-view/>',
					controller: [
						'$scope',
						'$timeout',
						function ($scope, $timeout) {
							$scope.showSplash = true;

							// Remove the index.html splash (layer 1) — no longer needed
							var htmlSplash = document.getElementById('html-splash');
							if (htmlSplash) {
								htmlSplash.remove();
							}

							// Listen for the Angular Element's dismissed event
							$timeout(function () {
								var el = document.getElementById('angular-splash');
								if (el) {
									el.addEventListener('dismissed', function () {
										$scope.$apply(function () {
											$scope.showSplash = false;
										});
									});
								}
							});
						},
					],
				},
			},
		});

		$stateProvider.state('public', {
			url: '/public/:link',
			parent: 'public-root',
			data: {
				admin: false,
				access: '*',
				title: 'Publication',
			},
			views: {
				'@public-root': {
					templateUrl: './src/components/modules/hd/dashboard/publication.html',
					controller: 'PublicationController',
				},
			},
		});

		// Reached from the project export mail. The link cannot point at /service/** directly:
		// an unauthenticated browser gets a bare 401 there, never a login page. Landing on a front
		// route instead, the usual bootstrap signs the user in and brings them back here, and the
		// download then rides the session like any other navigation.
		$stateProvider.state('project-export-download', {
			url: '/export/download/:executionId/:link',
			parent: 'public-root',
			data: {
				admin: false,
				access: '*',
				title: 'Export',
			},
			views: {
				'@public-root': {
					templateUrl:
						'./src/components/modules/export-history/download.html',
					controller: [
						'$scope',
						'$rootScope',
						'$stateParams',
						'$window',
						'API_BASE_URL_BACKEND',
						function (
							$scope,
							$rootScope,
							$stateParams,
							$window,
							API_BASE_URL_BACKEND
						) {
							var executionId = $stateParams.executionId;
							var link = $stateParams.link;
							$scope.error = !executionId || !link;
							if ($scope.error) {
								return;
							}
							// The path comes from the backend's own map, like every other call:
							// hard-coding it here would be a second copy of the route.
							var path = $rootScope
								.getUrl('PROJECTS_EXPORT_DOWNLOAD')
								.replace('{executionId}', encodeURIComponent(executionId))
								.replace('{link}', encodeURIComponent(link));
							var downloadUrl = API_BASE_URL_BACKEND + path;

							// Navigated to, not opened in a tab: the response is an attachment,
							// so the browser takes the file and leaves this page standing. A second
							// tab would only flash and close. When the link is dead the backend
							// answers with an error instead, and the page stays as it is.
							$scope.startDownload = function () {
								$window.location.href = downloadUrl;
							};
							$scope.startDownload();
						},
					],
				},
			},
		});

		$stateProvider.state('data', {
			url: '/data/:rootCode/:dbName/info',
			parent: 'public-root',
			data: {
				admin: false,
				access: '*',
				title: 'DataBlock',
			},
			views: {
				'@public-root': {
					templateUrl: './src/components/modules/datablocks/expose.html',
					controller: 'DbExposeController',
				},
			},
		});
	}
})();
